module.exports = __webpack_public_path__ + "img/banner_ruzhuyuncang.47f7a5c6.jpg";